<script setup>
import { inject, computed } from 'vue';
const config = inject('config');
const gaPush = inject('gaPush');

import { useProductsStore } from '@/app/stores/productsStore.js';

const productsStore = useProductsStore();

function handleGaClick() {
  const gaPayloadProductListing = {
    event: 'prod_spec_toggle_measurement_system',
  };

  const gaPayloadProductSpecification = {
    event: 'prod_det_toggle_measurement_system',
    product_name: config.productName,
  };

  const gaPayload = {
    ...(config.productName ? gaPayloadProductSpecification : gaPayloadProductListing),
    selected_measurement_system: productsStore.system || null,
    product_category: config.category,
  };

  gaPush(gaPayload);
}

function handleToggleChange($event) {
  productsStore.system = $event.target.value;
  productsStore.resetDynamicFiltersArr();
  handleGaClick();
}
</script>

<template>
  <fieldset
    class="c-product-listing-filter__toggle-switch"
    v-if="productsStore.displayToggle"
    @change="handleToggleChange"
  >
    <legend class="c-product-listing-filter__toggle-legend">
      {{ config.systemLabel }}
    </legend>
    <input
      type="radio"
      name="measuringSystem"
      id="radio-metric"
      value="metric"
      :checked="productsStore.isSystemMetric"
    />
    <label for="radio-metric">{{ config.metric }}</label>
    <input
      type="radio"
      name="measuringSystem"
      id="radio-imperial"
      value="imperial"
      :checked="!productsStore.isSystemMetric"
    />
    <label for="radio-imperial">{{ config.imperial }}</label>
  </fieldset>
</template>